/**
 * Supervisor pickup banner — Pro Tools yellow ribbon for supervisor notes.
 *
 * Fires when the supervisor has flagged the active cue for re-record. PT
 * yellow chrome with black border + black text — the same visual vocabulary
 * the rest of the surface uses for warnings.
 */
import { copy } from '@ohear/shared'

export interface SupervisorBannerProps {
  supervisorName: string | null
  note: string | null
  locale?: 'zh' | 'en'
}

export function SupervisorBanner({ supervisorName, note, locale = 'en' }: SupervisorBannerProps) {
  if (!supervisorName) return null
  const banner = copy.pickup.pickupBanner(supervisorName, note)
  const text = locale === 'zh' ? banner.zh : banner.en
  return (
    <div role="alert" className="pt-ribbon flex items-start gap-3 px-3 py-2 text-[13px]">
      <span
        aria-hidden="true"
        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-sm border border-pt-text bg-pt-rec text-[14px] text-white"
      >
        !
      </span>
      <div className="flex-1 whitespace-pre-line leading-relaxed text-pt-text">{text}</div>
    </div>
  )
}
